/* eslint-disable jsx-a11y/label-has-associated-control */
import { FunctionComponent, ReactNode } from 'react';
import styles from './Label.module.scss';

export type LabelProps = {
  label: ReactNode;
  variant?: 'dropdown';
  required: boolean;
  isBold?: boolean;
  hasNoPadding?: boolean;
  padding?: string;
  optionalSignifier?: string;
  labelfontSize?: string;
  htmlFor?: string;
  color?: 'black' | 'dark-grey' | 'grey' | 'light-grey' | 'red';
  textAlign?: 'left' | 'right' | 'center';
  className?: string;
};

type FC = FunctionComponent<LabelProps>;

const Label: FC = (props: LabelProps): React.JSX.Element => {
  const {
    label,
    variant,
    required = true,
    isBold = true,
    hasNoPadding = false,
    padding = '20px 0 6px',
    color = 'black',
    optionalSignifier,
    labelfontSize,
    textAlign = 'left',
    htmlFor = '',
    className,
  } = props;

  return (
    <label
      className={[
        className,
        styles.label,
        styles[color],
        styles[getNormalFontClass()],
        styles[getPaddingClass()],
        styles[variant === 'dropdown' ? 'dropdown' : ''],
      ].join(' ')}
      style={{ padding, fontSize: labelfontSize, textAlign }}
      htmlFor={htmlFor}
    >
      {label}
      {required && <span className={styles.icon}>*</span>}
      {optionalSignifier && <span className={styles.optionalSignifier}>{optionalSignifier}</span>}
    </label>
  );

  function getNormalFontClass() {
    return isBold ? '' : 'normal';
  }

  function getPaddingClass() {
    return hasNoPadding ? 'noPadding' : '';
  }
};

export default Label;
